export default __webpack_public_path__ + "static/media/telegram.3901d561.svg";